<div [attr.aria-label]="'HängigeGeschäfte' | translate" class="mt-3">
  <cap-haengige-gb-geschaefte [hasRight]="hasRight" [loadOption]="loadOption" [perimeter]="perimeter"></cap-haengige-gb-geschaefte>

  <cap-haengige-geo-geschaefte [hasRight]="hasRight" [loadOption]="loadOption" [perimeter]="perimeter"></cap-haengige-geo-geschaefte>

  @if (auftragsmodul) {
    <cap-haengige-auftraege [hasRight]="hasRight" [loadOption]="loadOption" [perimeter]="perimeter"></cap-haengige-auftraege>
  }
</div>
